const r = (o, s) => {
  let e;
  return function(...t) {
    const c = () => {
      clearTimeout(e), o(...t);
    };
    clearTimeout(e), e = setTimeout(c, s);
  };
}, n = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
export {
  r as i,
  n as r
};
